import { appendTerminalChunk } from "../model/terminal-lines";
// The pure half of the terminal chat block: how a stream of text chunks
// becomes rows.
//
// A chat stream delivers arbitrary slices — a delta may end mid-row, carry
// several rows, or be one lone newline — while the terminal block's model is
// `lines: string[]` with the LAST element open (the row still being written).
// This module owns that fold and nothing else, in its own file because the
// plugin module imports DOM components at module scope and this is the part
// that wants unit tests rather than screenshots.

export namespace ChatTerminalLines {
  /**
   * Fold one chunk into a line list. Returns a new array; never mutates.
   *
   * The invariant on both sides: the last element is the open row. An empty
   * list means "nothing yet", and a chunk arriving then opens the first row —
   * so `[]` then `"a"` is `["a"]`, and `[]` then `"\n"` is `["", ""]`: one
   * closed empty row, one open.
   */
  export function appendChunk(lines: readonly string[], chunk: string): string[] {
    const next = lines.slice();
    appendTerminalChunk(next, chunk);
    return next;
  }

  /**
   * Which rows changed between a list and its fold — the open row that grew,
   * plus everything appended after it. Lets a painter repaint two rows on a
   * 2000-row tail instead of two thousand.
   */
  export function changedFrom(before: readonly string[], after: readonly string[]): number {
    // Every row before the previously-open one is closed and immutable.
    return Math.max(0, before.length - 1);
  }
}
